/**
 * デジタコマスタページ用のスクリプト
 */
if (is_route('digitacho_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        digitacho_setting_event_set();
    });
}

if (is_route('digitacho_setting.change') || is_route('digitacho_setting.view')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        digitacho_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.digitacho_setting_event_set = function() {

    let csvSettingModalId = '#digitacho_setting-csv-setting-modal';
    let csvFormId = csvSettingModalId + '-form';

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#digitacho_setting-all-check', function () {
        $(".digitacho_setting-check").prop('checked', $(this).prop('checked'));
    });

    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#digitacho_setting-all-check, .digitacho_setting-check', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#search-form-action_download').prop('disabled', ($('.digitacho_setting-check:checked').length == 0));
    });

    // 戻るボタン押下時

    $(document).on('click', '#change-cancel', function () {
        let action = extend_url_query($(this).data('action'));
        location.href=action;
    });

    // グループ会社セレクトボックスの変更時
    $(document).on('change', '#digitacho_setting-change-form-holding_id', function () {
        $('.vehicle_list_row').remove();
    });

    // 会社セレクトボックスの変更時
    $(document).on('change', '#digitacho_setting-change-form-company_id', function () {
        datas = {
            'id': $('.vehicle_list_box').data('setting_id'),
            'holding_id': $('#digitacho_setting-change-form-holding_id').val(),
            'company_id': $(this).val()
        };
        action = $('.vehicle_list_box').data('action');
        _ajax.post(action, datas, function(results) {
            $('.vehicle_list_box').html(results.list_view);
            $('.vehicle_type_box').html(results.vehicle_type);
            $('.vehicle_type_box select.select2').select2({ width: "100%" });

        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

    //検索ボタン
    $(document).on('click', '#digitacho_setting-change-form-vehicle_search_btn', function (event) {
        event.stopPropagation();

        let select_section = $('#digitacho_setting-change-form-section_id').val();
        let vehicle_classification_name = $('#digitacho_setting-change-form-vehicle_classification_name').val();
        let list_table = $(".vehicle_list_table");
        let row_count = list_table.find("tr").length;

        if(select_section || vehicle_classification_name) {
            // 営業所か車両区分が指定されていたらリストの内容を絞り込む
            for (let i = 2; i <= row_count; i++) {
                tr = list_table.find("tbody tr:nth-child(" + i + ")");
                section_id = tr.data('section_id');
                vehicleclassification_name = tr.data('vehicleclassification_name');
                show_flg = true;
                if((select_section && (select_section != section_id))
                || (vehicle_classification_name && (vehicle_classification_name != vehicleclassification_name))) {
                    show_flg = false;
                }
                if(show_flg) {
                    tr.show();
                } else {
                    tr.hide();
                }
            }
        } else {
            //どちらも選択されていなかったらすべて表示
            for (let i = 1; i <= row_count; i++) {
                tr = list_table.find("tbody tr:nth-child(" + i + ")");
                tr.show();
            }
        }
    });

    // クリアボタン
    $(document).on('click', '#digitacho_setting-change-form-vehicle_clear_btn', function (event) {
        event.stopPropagation();
        $('#digitacho_setting-change-form-section_id').select2().val(null).trigger('change');;
        $('#digitacho_setting-change-form-vehicle_classification_name').val(null).trigger('change');
        let list_table = $(".vehicle_list_table");
        let row_count = list_table.find("tr").length;
        for (let i = 1; i <= row_count; i++) {
            tr = list_table.find("tbody tr:nth-child(" + i + ")");
            tr.show();
        }
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // basic_idsの初期化
        let ids = [];
        // 検索フォームを配列化
        let data = $('#search-form').serializeArray();
        // チェックされていない場合はスキップ
        if($('.digitacho_setting-check:checked').val() == null) {
            return false;
        }
        // basic_ids取得
        $('.digitacho_setting-check:checked').map(function () {
            ids.push($(this).val());
        });
        data.push({'name' : 'ids', 'value' : ids});
        // ポスト送信を実行
        post(action, data);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', csvSettingModalId + '-csv', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).data('confirm-action');
        let datas = new FormData($(csvFormId).get(0));
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $("[data-csv-save-modal]").prop('disabled', true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(csvSettingModalId + '-csv-submit-message').removeClass('display-none');
            $(csvSettingModalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(csvSettingModalId + '-csv-error').removeClass('display-none');
                $(csvSettingModalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let action = $(csvFormId).attr('action');
        let datas = new FormData($(csvFormId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(csvSettingModalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });

    $(document).on('click', '#change-submit', function () {
        let action = $('#digitacho_setting-change-form').attr('action');
        let datas = $('#digitacho_setting-change-form').serializeArray();
        //post(action, datas);
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                //画面遷移
                location.href=data.url;
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {
                    idName = "#"+name.replace(/\./g,'_')+'-id';
                    $(idName).addClass('is-invalid');
                    $(idName + '-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.error(errorMessage);
            }
        });
    });

    /*---- バイナリファイルダウンロード時 ----*/

    // バイナリファイルダウンロード時
    $(document).on('click', '#search-form-action_binary_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        let data = $('#search-form').serializeArray();
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});

        // ポスト送信を実行
        post(action,data);
    });
}
